import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import {
    changeTotalScore,
    setCurrentAnswerStatus,
} from '../../store/sessionStatus';
import Button from '../../components/button/Button';
import { Type6SelectSVG } from '../../assets/SVGAssets';

import './type6.css';

export default function Type6({ question, answer }) {
    const ref = useRef();

    const dispatch = useDispatch();

    const [imageLeft, setImageLeft] = useState(0);
    const [imageTop, setImageTop] = useState(0);
    const [imageHeight, setImageHeight] = useState(0);
    const [imageWidth, setImageWidth] = useState(0);

    const [answers, setAnswers] = useState([].concat(question.answers));
    const [disabledButton, setDisabledButton] = useState(false);

    const handleOnLoad = () => {
        setImageLeft(ref.current.offsetLeft);
        setImageTop(ref.current.offsetTop);
        setImageHeight(ref.current.getBoundingClientRect().height);
        setImageWidth(ref.current.getBoundingClientRect().width);
    };

    const handleWindowResize = () => {
        if (ref.current?.complete) {
            handleOnLoad();
        }
    };

    useEffect(() => {
        window.addEventListener('resize', handleWindowResize);
        return () => {
            window.removeEventListener('resize', handleWindowResize);
        };
    });

    const createSvg = (index) => {
        if (!disabledButton)
            setAnswers((current) =>
                current.map((ans, i) => {
                    if (i === index) {
                        return {
                            ...ans,
                            color: !ans.selected ? 'white' : 'transparent',
                            selected: !ans.selected,
                        };
                    }
                    return ans;
                }),
            );
    };
    const checkAnswer = () => {
        setAnswers((prevState) => {
            const newState = prevState.map((answer) => {
                if (answer.isCorrect) {
                    return { ...answer, color: '#40D2FF' };
                } else return { ...answer, color: 'rgba(245, 31, 248, 1)' };
            });
            return newState;
        });

        const status =
            answers.filter((answer) => answer.selected !== answer.isCorrect)
                .length === 0;

        dispatch(setCurrentAnswerStatus(status));

        if (status) {
            dispatch(changeTotalScore(question.points));
        }

        setTimeout(() => answer(), 1500);
        setDisabledButton(true);
    };

    return (
        <div className="questionWrapper">
            <div className="type6-text">
                <p>{question.text}</p>
            </div>

            <div className="type6-imageArea">
                <img
                    ref={ref}
                    onLoad={handleOnLoad}
                    className="imageBg"
                    src={question.image}
                    alt={question.text}
                />
                <div className="imageArea">
                    {answers.map((answer, i) => {
                        return (
                            <React.Fragment key={i}>
                                <Type6SelectSVG
                                    onClick={createSvg}
                                    left={`${
                                        imageLeft +
                                        imageWidth * answer.position.x
                                    }px`}
                                    top={`${
                                        imageTop +
                                        imageHeight * answer.position.y
                                    }px`}
                                    width={`${imageWidth * answer.width}px`}
                                    height={`${imageHeight * answer.height}px`}
                                    color={answer.color}
                                    index={i}
                                />
                            </React.Fragment>
                        );
                    })}
                </div>
            </div>
            <div className="nextQuestionButton">
                <Button
                    disabled={disabledButton}
                    type={'checkButton'}
                    text={'check'}
                    action={checkAnswer}
                />
            </div>
        </div>
    );
}
